import styled from "styled-components";
import { useAppSelector } from "../../../../../../redux";
import { getIsARepost } from "../../../../../../utils";
import { FlexColumn } from "../../../../../Common/Styles";
import { PostCardContent, usePostCardContext } from "../PostCardContent";
import { ContentUnavailable } from "./ContentUnavailable";

export const RepostContent = () => {
  const { postId } = usePostCardContext();
  const { processed_posts } = useAppSelector((state) => state.newsfeed);
  const post = processed_posts[postId];

  const isARepost = getIsARepost(post.EmbedPostID);
  if (!isARepost) return null;
  const originalPostId = post?.EmbedPostID;
  const originalPost = processed_posts[originalPostId];
  if (!originalPost) return null;

  const IsEmbeddedActive = processed_posts[postId];
  if (!IsEmbeddedActive) return <ContentUnavailable />;

  return (
    <RepostContainer $gapInPx={10} className="repost-container">
      <RepostWrapper>
        <PostCardContent postId={post.EmbedPostID} isWithinRepostPost />
      </RepostWrapper>
    </RepostContainer>
  );
};

const RepostContainer = styled(FlexColumn)`
  padding: ${({ theme }) =>
    `${theme.spacing["spacing-2"].value}rem ${theme.spacing["spacing-4"].value}rem`};
`;
const RepostWrapper = styled.div(
  ({ theme }) => `
  border-radius: ${theme.radius["radius-xs"].value}rem;
  gap: ${theme.spacing["spacing-2"].value}rem;
  border: ${theme.border_width["border-width-thin"].value}rem solid ${theme.Color.border["ui-border-neutral"].value};
`
);
